import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "3302 391 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3312 411a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.175-2.138q-1.35-1.35-2.137-3.175a9.7 9.7 0 0 1-.788-3.9 9.7 9.7 0 0 1 .788-3.9 10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.138a9.7 9.7 0 0 1 3.9-.787q2.075 0 3.9.787a10.1 10.1 0 0 1 3.175 2.138q1.35 1.35 2.137 3.175a9.7 9.7 0 0 1 .788 3.9 9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.138a9.7 9.7 0 0 1-3.9.787m0-2q3.35 0 5.675-2.325T3320 401q0-.175-.013-.362a5 5 0 0 1-.012-.313 1.98 1.98 0 0 1-.675 1.2q-.55.475-1.3.475h-2q-.824 0-1.413-.588A1.93 1.93 0 0 1 3314 400v-1h-4v-2q0-.825.587-1.412A1.93 1.93 0 0 1 3312 395h1q0-.574.313-1.013a2.6 2.6 0 0 1 .762-.712q-.5-.125-1.012-.2A7 7 0 0 0 3312 393q-3.35 0-5.675 2.325T3304 401h5q1.65 0 2.825 1.175T3313 405v1h-3v2.75q.5.125.987.188.488.062 1.013.062",
      class: "fills",
      style: {"fill":"#1f7eff","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }